export enum EPostMessageType {
  ACA_FRAME_RENDERED = 'acaFrameRendered',
  ACA_LOGIN_PAGE_READY = 'acaLoginPageReady',
  BOOK_FROM_PREVIOUS_ORDER = 'bookFromPreviousOrder',
  BUSINESS_SOLUTION_CHANGE = 'businessSolutionChange',
  CLEAR_AUTH_DATA = 'clearAuthData',
  CLEAR_AUTH_DATA_SUCCESS = 'clearAuthDataSuccess',
  COMPANY_LOGO_CHANGE = 'companyLogoChange',
  CREATE_CAP = 'createCAP',
  LANGUAGE_CHANGE = 'languageChange',
  LOAD = 'load',
  LOGIN_FROM_MYQIMA = 'loginFromMyQima',
  LOGIN_FROM_MYQIMA_SUCCESS = 'loginFromMyQimaSuccess',
  LOGOUT = 'Logout',
  MFA_DATA = 'MFAData',
  ORDER_CREATED_FROM_PREVIOUS_ORDER = 'orderCreatedFromPreviousOrder',
  PATH_CHANGE = 'pathChange',
  PAY_BY_TRANSFER_SHOW = 'payByTransferShow',
  PAYMENT_MODAL_SHOW = 'paymentModalShow',
  RELOAD = 'reload',
  ROUTE_CHANGE = 'routeChange',
  SELECT_PREVIOUS_CERTIFICATION_SHOW = 'selectPreviousCertificationShow',
  SET_STORAGE = 'setStorage',
  STATE_GO = 'stateGo',
  UPDATE_USER_DATA = 'updateUserData',
  VIEW_CAP = 'viewCAP',
  VIEW_MORE_PREVIOUS_ORDERS = 'viewMorePreviousOrders',
  VIEW_ORDER = 'viewOrder',
  VIEW_ORDER_FILES = 'viewOrderFiles',
  VIEW_ORDER_ON_CALENDAR = 'viewOrderOnCalendar',
  VIEW_ORDER_ON_HOMEPAGE = 'viewOrderOnHomePage',
  VIEW_REPORT = 'viewReport',
}
